var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mutant-logo",class:{
    'mutant-logo--can-open': _vm.$roleAwareness.isUser,
    'mutant-logo--is-highlighted': _vm.isOpen,
  }},[_c('span',[_vm._v("MUTANT")]),_vm._v(" "),(_vm.$roleAwareness.isPayingRole)?_c('span',{staticClass:"mutant-logo__alpha"},[_vm._v(_vm._s('ALPHA'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }